/**
 * Country data processing utilities
 */

/**
 * Process client data into country data
 * @param {Array} clientData - The client data
 * @returns {Object} Object containing country data and totals
 */
export const processCountryData = (clientData) => {
  const countryMap = {};
  const mgrSet = new Set();
  
  clientData.forEach(obj => {
    const size = +obj.group_size;
    const lat = +obj.latitude;
    const lng = +obj.longitude;
    const mgr = obj.conference_manager;
    const country = obj.country;
    
    if (!size || isNaN(lat) || isNaN(lng)) return;

    mgrSet.add(mgr);
    
    if (!countryMap[country]) {
      countryMap[country] = {
        country,
        latitude: lat,
        longitude: lng,
        total: 0,
        largest: 0,
        managers: new Set(),
        dominantManager: null
      };
    }
    
    const c = countryMap[country];
    c.total++;
    c.managers.add(mgr);
    
    if (size > c.largest) {
      c.largest = size;
      c.dominantManager = mgr;
    }
  });

  const allManagers = [...mgrSet];
  
  const countryData = Object.values(countryMap).map(c => ({
    country: c.country,
    latitude: c.latitude,
    longitude: c.longitude,
    total: c.total,
    largest: c.largest,
    dominantManager: c.dominantManager,
    managers: Array.from(c.managers)
  }));

  const totals = {
    entries: countryData.reduce((s, c) => s + c.total, 0),
    countries: countryData.length,
    managers: allManagers.length
  };

  return {
    countryData,
    totals,
    allManagers
  };
};
